import { render, staticRenderFns } from "./MyMarkets.vue?vue&type=template&id=b568159a&"
import script from "./MyMarkets.vue?vue&type=script&lang=js&"
export * from "./MyMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports